// @flow
export const FETCH = 'locations/FETCH'
export const SUCCESS = 'locations/SUCCESS'
export const ERROR = 'locations/ERROR'

const initialState = {
  fetchErrors: null,
  availableLocations: [],
  isFetching: false
}

export const locationsFetchRequest = () => {
  return {
    type: FETCH,
    payload: {}
  }
}

export const locationsFetchSuccess = locations => {
  return {
    type: SUCCESS,
    payload: { locations }
  }
}

export const locationsFetchError = errors => {
  return {
    type: ERROR,
    error: true,
    payload: {
      errors
    }
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        ...state,
        isFetching: true
      }
    case SUCCESS:
      return {
        ...state,
        isFetching: false,
        availableLocations: action.payload.locations
      }
    case ERROR:
      return {
        ...state,
        fetchErrors: action.payload.errors
      }
    default:
      return state
  }
}

export default reducer
export * from './saga'



// WEBPACK FOOTER //
// ./src/ducks/locations/index.js